export const fields = [
  {
    name: "child_under_6_required",
    engText:
      "A child 5 years or younger resides or routinely spends 10 or more hours each week in your home.",
    spnText:
      "Un niño de 5 años o menos reside o pasa rutinariamente 10 o más horas cada semana en su hogar",
    children: [],
  },
  {
    name: "child_under_10",
    engText: "A child 10 years or younger resides or routinely spends 10 or ore hours each week in your home and",
    spnText: "Un niño de 10 años o menos reside o pasa rutinariamente 10 o más horas cada semana en su hogar.",
    children: [
      {
        name: "window_guards_installed",
        value: true,
        engText: " Window guards are installed in all windows as required.",
        spnText:
          "Se instalan protectores de ventanas en todas las ventanas según sea necesario.",
      },
      {
        name: "window_guards_installed",
        value: "repair",
        engText: "Window guards are installed but need repair",
        spnText:
          "Las protecciones de las ventanas están instaladas pero necesitan reparación.",
      },
      {
        name: "window_guards_installed",
        value: false,
        engText: "Window guards are NOT installed in all windows as required",
        spnText: "Los protectores de ventanas NO están instalados en todas las ventanas según sea necesario.",
      },
    ],
  },
  {
    name: "child_under_10_not_living",
    engText: "No child 10 years or younger resides or routinely spends 10 or more hours each week in your home and",
    spnText: "Ningún niño de 10 años o menos reside ni pasa rutinariamente 10 o más horas cada semana en su hogar.",
    children: [
      {
        name: "window_guards_installed_anyway",
        value: true,
        engText: "I want window guards installed anyway",
        spnText:
          "Quiero instalar protectores de ventana de todos modos",
      },
      {
        name: "window_guards_installed_anyway",
        value: false,
        engText: "I have window guards but they need repair",
        spnText: "Tengo protectores de ventanas pero necesitan reparación.",
      },
    ],
  },
];

export const surveyDetailsFields = [
  { name: "first_name", label: "First Name", type: "text", size: 6 },
  { name: "last_name", label: "Last Name", type: "text", size: 6 },
  { name: "phone_number", label: "Telephone #", type: "number", size: 6 },
  { name: "dates", label: "Date (Fecha)", type: "date", size: 6 },
  // {
  //   name: "response_type",
  //   label: "Response Type",
  //   type: "select",
  //   size: 4,
  //   placeholder: "Select Response Type",
  //   options: [
  //     {
  //       label: "DROPBOX",
  //       value: "DROPBOX",
  //     },
  //     {
  //       label: "DOOR KNOCK",
  //       value: "DOOR KNOCK",
  //     },
  //     {
  //       label: "RESPONSE TO OWNER",
  //       value: "RESPONSE TO OWNER",
  //     },
  //     {
  //       label: "QR RESPONSE",
  //       value: "QR RESPONSE",
  //     },
  //     {
  //       label: "BY MAIL",
  //       value: "BY MAIL",
  //     },
  //   ],
  // },
];
